module.exports = __webpack_public_path__ + "static/media/super_pack_en_chien_hiver.8e7c07d5.png";